import { post } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const doPaymentPost = record => post(url.DO_PAYMENT_POST,record)
export const doPaymentSignVoid = record => post(url.DO_PAYMENT_SIGN_VOID,record)
export const doPaymentSignRefund = record => post(url.DO_PAYMENT_SIGN_REFUND,record)